(() => {
  const root = () => (window.Shopify?.routes?.root || '/');

  const getDrawer = () => document.querySelector('#MinimogCartDrawer');

  // Free-shipping test: no discount-code entry/storage on the free-shipping template
  // or when the cart holds only the free-shipping test product. Checkout still accepts codes.
  const fsBlocked = () => window.vmFreeShipTemplate === true
    || Boolean(document.querySelector('[data-vm-fs-only-cart]'));

  const setMessage = (container, text, type = '') => {
    const el = container?.querySelector('[data-vm-cart-discount-message]');
    if (!el) return;
    el.textContent = text || '';
    el.classList.remove('is-success', 'is-error');
    if (type) el.classList.add(type === 'success' ? 'is-success' : 'is-error');
  };

  const moneyFromCents = (cents, currencyCode) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currencyCode || window.Shopify?.currency?.active || 'USD',
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const refreshDrawer = async () => {
    const drawer = getDrawer();
    const currentShell = drawer?.querySelector('[data-vm-cart-discount-shell]');

    try {
      const response = await fetch(`${root()}cart?section_id=cart-drawer`, {
        headers: { 'Accept': 'text/html' }
      });
      if (!response.ok) throw new Error('Unable to refresh cart.');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextShell = doc.querySelector('[data-vm-cart-discount-shell]');

      if (currentShell && nextShell) {
        currentShell.replaceWith(nextShell);
      } else if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
        drawer.onCartDrawerUpdate(true);
      } else {
        window.location.reload();
      }
    } catch (_) {
      if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
        drawer.onCartDrawerUpdate(true);
      } else {
        window.location.reload();
      }
    }
  };

  const applyDiscount = async (container) => {
    const input = container.querySelector('[data-vm-cart-discount-input]');
    const button = container.querySelector('[data-vm-cart-discount-apply]');
    if (fsBlocked()) return;
    const code = (input?.value || '').trim();

    if (!code) {
      setMessage(container, 'Enter a discount code.', 'error');
      input?.focus();
      return;
    }

    button.disabled = true;
    button.textContent = 'Applying…';
    setMessage(container, '');

    try {
      const response = await fetch(`${root()}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: code })
      });

      const cart = await response.json();
      if (!response.ok || cart?.status) {
        throw new Error(cart?.description || cart?.message || 'Unable to apply this code.');
      }

      // Shopify accepts discount codes through /cart/update.js, but not every code
      // produces a cart-level discount immediately. For example, shipping discounts
      // can require an address / checkout context, and the discount application title
      // can differ from the literal code. Treat a successful API response as accepted.
      const immediateDiscount = Number(cart?.total_discount || 0);
      const hasImmediateApplication = Array.isArray(cart?.cart_level_discount_applications)
        && cart.cart_level_discount_applications.length > 0;

      if (immediateDiscount > 0 || hasImmediateApplication) {
        setMessage(container, '', '');
      } else {
        setMessage(container, 'Code added — final savings will be confirmed at checkout.', 'success');
      }

      if (!fsBlocked()) {
        try {
          localStorage.setItem('verymill_active_discount_code', code);
        } catch (_) {}
      }

      input.value = '';

      // Re-render discount + subtotal from Shopify so any immediately calculated
      // discount is reflected in the drawer without requiring a page refresh.
      await refreshDrawer();

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (error) {
      setMessage(container, error?.message || 'Unable to apply this code. Please try again.', 'error');
    } finally {
      button.disabled = false;
      button.textContent = 'Apply';
    }
  };

  const removeDiscount = async (button) => {
    const container = document.querySelector('[data-vm-cart-discount-code]');
    setMessage(container, '');
    button.disabled = true;

    try {
      const response = await fetch(`${root()}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: '' })
      });

      const cart = await response.json();
      if (!response.ok || cart?.status) {
        throw new Error(cart?.description || cart?.message || 'Unable to remove this code.');
      }

      try {
        localStorage.removeItem('verymill_active_discount_code');
        localStorage.removeItem('verymill_prime10_state');
        sessionStorage.removeItem('verymill_prime10_pending_once');
      } catch (_) {}

      await refreshDrawer();
      document.dispatchEvent(new CustomEvent('vm:discount-removed', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (error) {
      setMessage(container, error?.message || 'Unable to remove this code. Please try again.', 'error');
    } finally {
      button.disabled = false;
    }
  };


  document.addEventListener('click', (event) => {
    const applyButton = event.target.closest('[data-vm-cart-discount-apply]');
    if (applyButton) {
      event.preventDefault();
      const container = applyButton.closest('[data-vm-cart-discount-code]');
      if (container) applyDiscount(container);
      return;
    }

    const removeButton = event.target.closest('[data-vm-cart-discount-remove]');
    if (removeButton) {
      event.preventDefault();
      removeDiscount(removeButton);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest?.('[data-vm-cart-discount-input]');
    if (!input) return;
    event.preventDefault();
    const container = input.closest('[data-vm-cart-discount-code]');
    if (container) applyDiscount(container);
  });
})();
